export default {
  methods: {
    mapLayerLanduseCratenureAdd() {
      this.initPollLanduseCratenure();

      this.map.addSource("landuse-cratenure-source", {
        type: "geojson",
        data: this.computedLanduseCratenureGeoJson
      });

      this.map.addLayer({
        filter: ["==", "class", 1],
        id: "landuse-cratenure-1",
        source: "landuse-cratenure-source",
        type: "line",
        paint: {
          "line-color": "purple",
          "line-width": 2
        }
      });

      this.map.addLayer({
        filter: ["==", "class", 2],
        id: "landuse-cratenure-2",
        source: "landuse-cratenure-source",
        type: "line",
        paint: {
          "line-color": "#1be1ff",
          "line-width": 2
        }
      });

      this.map.addLayer({
        filter: ["==", "class", 3],
        id: "landuse-cratenure-3",
        source: "landuse-cratenure-source",
        type: "line",
        paint: {
          "line-color": "#96ff65",
          "line-width": 2
        }
      });

      this.map.addLayer({
        filter: ["==", "class", 1],
        id: "landuse-cratenure-fill-1",
        source: "landuse-cratenure-source",
        type: "fill",
        paint: {
          "fill-color": "purple",
          "fill-opacity": 0.1
        }
      });

      this.map.addLayer({
        filter: ["==", "class", 2],
        id: "landuse-cratenure-fill-2",
        source: "landuse-cratenure-source",
        type: "fill",
        paint: {
          "fill-color": "#1be1ff",
          "fill-opacity": 0.1
        }
      });

      this.map.addLayer({
        filter: ["==", "class", 3],
        id: "landuse-cratenure-fill-3",
        source: "landuse-cratenure-source",
        type: "fill",
        paint: {
          "fill-color": "#96ff65",
          "fill-opacity": 0.1
        }
      });

      this.map.moveLayer("landuse-cratenure-1", "marker-layer-polygons");
      this.map.moveLayer("landuse-cratenure-3", "marker-layer-polygons");
      this.map.moveLayer("landuse-cratenure-2", "marker-layer-polygons");

      this.map.moveLayer("landuse-cratenure-fill-1", "marker-layer-polygons");
      this.map.moveLayer("landuse-cratenure-fill-2", "marker-layer-polygons");
      this.map.moveLayer("landuse-cratenure-fill-3", "marker-layer-polygons");
    },
    mapLayerLanduseCratenureRemove() {
      this.cancelPollLanduseCratenure();
      this.map.removeLayer("landuse-cratenure-1");
      this.map.removeLayer("landuse-cratenure-2");
      this.map.removeLayer("landuse-cratenure-3");
      this.map.removeLayer("landuse-cratenure-fill-1");
      this.map.removeLayer("landuse-cratenure-fill-2");
      this.map.removeLayer("landuse-cratenure-fill-3");

      this.map.removeSource("landuse-cratenure-source");
    },
    initPollLanduseCratenure() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/landuse/cratenure",
        dept: "landuse",
        layer: "cratenure",
        token: this.computedAuthToken
      });
      this.pollLanduseCratenureInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/landuse/cratenure",
          dept: "landuse",
          layer: "cratenure",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollLanduseCratenure() {
      this.pollLanduseCratenureInterval = clearInterval(
        this.pollLanduseCratenureInterval
      );
    }
  },
  computed: {
    computedLanduseCratenureGeoJson() {
      return this.$store.state.mapLayers.landuse.layers.cratenure.geojson;
    },
    computedLanduseCratenureMapVisibility() {
      return this.$store.state.mapLayers.landuse.layers.cratenure.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.landuse.layers.cratenure.geojson": {
      handler() {
        if (this.computedLanduseCratenureGeoJson) {
          this.mapLayerLanduseCratenureRemove();
          this.mapLayerLanduseCratenureAdd();
        }
      }
    },
    "$store.state.mapLayers.landuse.layers.cratenure.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerLanduseCratenureAdd();
      } else {
        this.mapLayerLanduseCratenureRemove();
      }
    },
    "$store.state.mapLayers.patrol.layers.cratenure.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerLanduseCratenureAdd();
      } else {
        this.mapLayerLanduseCratenureRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollLanduseCratenure();
  }
};
